import React, { useState } from "react";

export default function Step1Email({ value, onChange, onNext }) {
  const [error, setError] = useState("");
  const validateEmail = (email) =>
    /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(
      email
    );

  const handleNext = () => {
    if (!value) setError("Email is required");
    else if (!validateEmail(value)) setError("Invalid email address");
    else {
      setError("");
      onNext();
    }
  };

  return (
    <div className="bg-gradient-to-br from-blue-50 via-white to-green-50 rounded-2xl shadow-2xl border border-blue-100 p-8 max-w-3xl mx-auto space-y-6">
      {" "}
      <label className="block mb-3 font-semibold text-gray-800">
        Email Address <span className="text-red-600">*</span>
      </label>
      <input
        type="email"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        className={`w-full p-3 border rounded-lg transition-colors duration-300 focus:outline-none focus:ring-2 focus:ring-blue-300 ${
          error
            ? "border-red-500 bg-red-50 placeholder-red-400"
            : "border-gray-300 bg-white placeholder-gray-400"
        }`}
        placeholder="you@email.com"
        aria-invalid={error ? "true" : "false"}
        aria-describedby="email-error"
      />
      {error && (
        <p
          id="email-error"
          className="text-red-600 text-sm mt-2 font-medium select-none"
          role="alert"
        >
          {error}
        </p>
      )}
      <button
        onClick={handleNext}
        className="mt-8 w-full bg-gradient-to-r from-blue-500 to-blue-600 hover:from-blue-600 hover:to-blue-700 text-white py-3 rounded-lg font-semibold shadow-md transition duration-300 ease-in-out focus:outline-none focus:ring-4 focus:ring-blue-300"
        type="button"
      >
        Next
      </button>
    </div>
  );
}
